import React, { FC } from 'react'

import Component from '.'
import { getBlokContent } from '@app/utils/blok-content'
import { isNonEmptyArray } from '@app/utils/type-check'
import { SearchOverlayWrapper } from '@app/components/search-overlay-wrapper'
import { Blok } from '@app/typings/blok'

type Props = {
  header: Blok[]
  statusBanner: Blok[]
  footer: Blok[]
  search: Blok[]
  navigation: Blok[]
}

export const LayoutPage: FC<Props> = ({
  header,
  statusBanner,
  footer = [],
  search = [],
  navigation,
  children,
}) => {
  return (
    <div className="wrapper" style={{ minHeight: '100vh' }}>
      <SearchOverlayWrapper {...search[0]} />
      {header &&
        header.map((header) => (
          <Component
            key={header._uid}
            content={{
              ...header,
              articleNavigation: getBlokContent(navigation),
            }}
          />
        ))}

      <div className="main">
        {isNonEmptyArray(statusBanner) && (
          <Component content={getBlokContent(statusBanner)} />
        )}
        {children}
      </div>

      <div className="bottom">
        {footer &&
          footer.map((footer) => (
            <Component key={footer._uid} content={footer} />
          ))}
      </div>
    </div>
  )
}
